module.exports = __webpack_public_path__ + "static/media/uploadfile.5c2d5f9b.svg";